<ion-label *ngIf="params?.showMail">
	<span>{{ contactSelection.data.email }}&nbsp;</span>
</ion-label>
<ion-label *ngIf="displayName" class="group-title">{{ displayName }}</ion-label>
<ion-label *ngIf="contactSelection.details" class="details">
	<span>{{ contactSelection.details }}</span>
</ion-label>
